// extracted by mini-css-extract-plugin
export default {"footer":"BenefitsModal_footer__jhKjb","cancel_btn":"BenefitsModal_cancel_btn__FQgyG"};